import { render, staticRenderFns } from "./ModalCnae.vue?vue&type=template&id=08671111&scoped=true&"
import script from "./ModalCnae.vue?vue&type=script&lang=js&"
export * from "./ModalCnae.vue?vue&type=script&lang=js&"
import style0 from "./ModalCnae.vue?vue&type=style&index=0&id=08671111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08671111",
  null
  
)

export default component.exports